import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getKnownVariants } from "../../../../state/selectors/CardsUI.selectors";
import IconStar from "../../../../../../assets/images/svg/star.svg";
import style from "./clinVar.module.scss";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import { showClinvarCardBarchart } from "../../../../pages/variant/components/NcbiClinvar2/helpers";
import { gray300 } from "../../../../common/helpers/colors";

const ClinVarCard = ({ card, clinvarData }) => {
  const isDisabled = !clinvarData || !Object.keys(clinvarData[0] || {}).length;

  const calcColor = () => {
    if (clinvarData && clinvarData.length > 0) {
      const lastSignificance =
        clinvarData[0].clinical_significance.slice(-1)[0];
      return getPathogenicityColorByAllNames(lastSignificance);
    }
    return gray300;
  };

  const renderStars = () => {
    const stars = [];
    const { review_stars: reviewStars } = clinvarData?.[0] || {};

    for (let i = 0; i < 4; i++) {
      const isFilled = i < reviewStars;
      stars.push(
        <IconStar
          data-testid={isFilled ? "filled-stars" : "empty-stars"}
          key={i}
          className={`${style.icon} ${isFilled ? style.iconFilled : ""}`}
        />
      );
    }

    return stars;
  };

  const displaySignificance = (significance) => {
    return (
      <span
        className="tw-font-bold"
        style={{ color: getPathogenicityColorByAllNames(significance) }}
      >
        {significance}
      </span>
    );
  };

  const renderSignificance = () => {
    if (clinvarData && clinvarData.length > 0) {
      const clinicalSignificance = clinvarData[0].clinical_significance;

      const filteredSignificance = clinicalSignificance.filter(
        (s) =>
          s.includes("Pathogenic") ||
          s.includes("Benign") ||
          s.includes("Uncertain Significance")
      );

      if (
        clinicalSignificance.includes(
          "Conflicting Interpretations Of Pathogenicity"
        )
      ) {
        return (
          <span
            className="tw-font-bold"
            style={{
              color: getPathogenicityColorByAllNames(
                "Conflicting Interpretations Of Pathogenicity"
              ),
            }}
          >
            Conflicting
          </span>
        );
      }

      if (
        clinicalSignificance.filter((s) => s.includes("Pathogenic")).length ===
        2
      ) {
        return (
          <span>
            {displaySignificance("Pathogenic")}/
            {displaySignificance("Likely Pathogenic")}
          </span>
        );
      }

      if (
        clinicalSignificance.filter((s) => s.includes("Benign")).length === 2
      ) {
        return (
          <span>
            {displaySignificance("Benign")}/
            {displaySignificance("Likely Benign")}
          </span>
        );
      }

      if (filteredSignificance.length === 1) {
        return displaySignificance(filteredSignificance);
      }
    }

    return null;
  };

  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={calcColor()}
      secondaryTitle={
        clinvarData && clinvarData.length > 0 ? (
          <span>
            <span data-testid="clinvar-significance">
              {renderSignificance()}
            </span>{" "}
            <span data-testid="clinvar-stars">{renderStars()}</span>
          </span>
        ) : null
      }
    >
      <span>
        <span>{showClinvarCardBarchart(clinvarData)}</span>
      </span>
    </CardWrapper>
  );
};

ClinVarCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  clinvarData: PropTypes.arrayOf(
    PropTypes.shape({
      clinical_significance: PropTypes.arrayOf(PropTypes.string),
      num_submitters: PropTypes.number,
      review_stars: PropTypes.number,
      accessions: PropTypes.arrayOf(PropTypes.shape({})),
    })
  ),
};

ClinVarCard.defaultProps = {
  clinvarData: [],
};

const mapStateToProps = (state) => ({
  clinvarData: getKnownVariants(state),
});

export default connect(mapStateToProps)(ClinVarCard);
